import React, { Fragment, Component } from 'react';
import { Button, Card, Flex, Box, Heading, Text } from 'rebass';
import { Link } from 'react-router-dom';
import moment from 'moment';
import momentTimezone from 'moment-timezone';
import styled from 'styled-components';

import { compose, withApollo, Query } from 'react-apollo';
import { withToastManager } from 'react-toast-notifications';
import { withWizard } from 'react-albus';
import DoctorIcon from '../../static/doctorImage.png';

import withAnalytics from '../../lib/withAnalytics';
import SpinLoader from '../../components/SpinLoader';
import Review from './../scheduleDoctor/components/payment/review';
import withSession from '../../lib/withSession';
import { isToggleActive } from '../../components/featureToggle/toggles';
import { uuidv4 } from '../../utils/uuid';
import { isMobile } from 'react-device-detect';
import { Constants } from '../../utils/constants';
import CheckoutFormBridge, { CheckoutFormBridgeNew } from './CheckoutFormBridge';
import { GET_BRIDGE_ORDER_DETAILS } from '../../graphql';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import { useState } from 'react';
import { useEffect } from 'react';
import { useMount } from '../../utils/hooks/lifecycle';
import { AvatarImg } from '../landing/UpcomingVisitLabs';

const CARD_OPTIONS = {
  iconStyle: 'solid',
  style: {
    base: {
      iconColor: 'rgba(53, 78, 121, 0.5)',
      color: '#354E79',
      fontWeight: 300,
      fontFamily: 'Poppins, Open Sans, Segoe UI, sans-serif',
      fontSize: '14px',
      fontSmoothing: 'antialiased',
      border: '1px solid rgba(0, 0, 0, 0.1);',
      ':-webkit-autofill': {
        color: '#fce883',
      },
      '::placeholder': {
        color: 'rgba(53, 78, 121, 1)',
      },
    },
    invalid: {
      iconColor: 'rgba(255, 15, 0, 1)',
      color: 'rgba(255, 15, 0, 1)',
    },
  },
};

const Avatar = styled(Flex)`
  width: 160px;
  height: 160px;
  background: #fff;
  border-radius: 50%;
  border: 1px solid #ccc;
  overflow: hidden;
  align-items: center;
  justify-content: center;

  & > img {
    width: 200px;
  }
  @media screen and (min-width: 52em) {
    &.small {
      width: 60px;
      height: 60px;
      & > img {
        width: 60px;
      }
    }
  }
`;

const BoxRight = styled(Box)`
  width: 100%;
  @media screen and (min-width: 52em) {
    -webkit-transition: width 0.5s; /* For Safari 3.1 to 6.0 */
    transition: width 0.5s;
    &.loaded {
      width: 33%;
    }
  }
`;

const CardWrap = styled(Flex)`
  flex: 1;
  width: 100%;
  max-width: 700px;
`;

const CardMain = styled(Flex)`
  border-radius: 16px;
  padding: 8px;
  width: 100%;
  height: 100%;
  background: white;
  transition: all 0.3s ease;
  box-shadow: 0px 5.592px 20.969px 0px rgba(0, 0, 0, 0.08);
`;

const UpcomingCard = ({ children, text, onClick, noDescription = false, visitType = '', visitTypeFull = '' }) => {
  return (
    <CardWrap alignItems="center">
      <CardMain
        style={{ cursor: !!onClick ? 'pointer' : '', zIndex: 1 }}
        onClick={() => {
          if (!!onClick) {
            onClick();
          }
        }}
        className={!!onClick ? 'canClick' : ''}
      >
        <Flex alignItems={'center'} style={{ height: '100%' }}>
          {children[0]}
          <Flex flexDirection={'column'} justifyContent="center">
            {!!visitTypeFull && (
              <Text style={{ fontWeight: 500 }} mb={2}>
                {visitTypeFull}
              </Text>
            )}
            <Text style={{ fontWeight: 500 }}>{text}</Text>
            {children[1]}
          </Flex>
        </Flex>
      </CardMain>
    </CardWrap>
  );
};

const TextDescriptionAppointment = styled(Text)`
  transition-delay: 0.4s;
  opacity: 0;
  &.loaded {
    opacity: 1;
  }
`;

const BoxLeft = styled(Box)`
  width: 100%;
  @media screen and (min-width: 52em) {
    transform: scale(0);
    width: 0%;
    -webkit-transition: all 0.1s; /* For Safari 3.1 to 6.0 */
    transition: all 0.1s;
    transition-delay: 0.3s;
    &.loaded {
      width: 67%;
      transform: scale(1);
    }
  }
`;

const CheckoutFormNew = ({
  selectedAppointment,
  reinitFlow,
  wizard,
  session,
  addMembership,
  quadPaySubscribedData,
  bridgeServiceEligibility,
  setQuadPayData,
  client,
  newInsurance,
  onFileInsurance,
  analytics,
  toastManager,
  isNewPatientFlow,
  storeCard,
  handlePayment,
  isAdmin,
  enforcePatientId,
  duration,
  isWeightLoss,
  type,
  isMeno,
  basePath,
  consents,
  onCompleted,
  rescheduleAppointmentId,
  getPriceDescription,
}) => {
  const isMember = isWeightLoss ? session && session.isWeightLossMember : session && session.isMember;

  const hasMembership = isMember || !!addMembership || !!quadPaySubscribedData;
  // console.log({ addMembership });
  const [step, setStep] = useState('payment');
  const [isLoadingInsuranceQuote, setisLoadingInsuranceQuote] = useState();
  const [regularCost, setregularCost] = useState(hasMembership ? 60 : 110);

  const [copayCost, setcopayCost] = useState(bridgeServiceEligibility.patientResponsibility.total);
  const [copayLoaded, setcopayLoaded] = useState(false);
  const [copayError, setcopayError] = useState();
  const [billingSameAsShiping, setbillingSameAsShiping] = useState(true);
  const [forTheNext, setforTheNext] = useState(null);
  const [quadpayOrderReference, setquadpayOrderReference] = useState(uuidv4());
  const [order, setorder] = useState(null);
  const [membershipDescription, setMembershipDescription] = useState(getPriceDescription(addMembership));
  const [multiMembershipDescription, setMultiMembershipDescription] = useState(getPriceDescription(addMembership));
  const [multiMembershipDescription2, setMultiMembershipDescription2] = useState(getPriceDescription(addMembership));
  const [selectedFromMulti, setSelectedFromMulti] = useState('HormoneRebalance');

  useEffect(() => {
    if (!selectedAppointment) {
      reinitFlow(wizard);
      return;
    }
    if (!type || type === 'meno') {
      setMultiMembershipDescription(getPriceDescription('HormoneRebalance'));
      setMultiMembershipDescription2(getPriceDescription('MetabolicReset'));
    }
    getOrder(null, bridgeServiceEligibility.id);
    holdSpotForTheNextUpdate();
  }, []);

  const onCompleteCallback = function(result) {
    const { setQuadPayData } = this.props;
    const { quadpayOrderReference } = this.state;

    setQuadPayData(result.card.number, result.card.cvc, result.card.expirationMonth, result.card.expirationYear, quadpayOrderReference);
  };

  const getOrder = async (addons, bridgeServiceEligibilityId) => {
    // // console.log({ addons });
    let ord = {};

    const { data } = await client.query({
      query: GET_BRIDGE_ORDER_DETAILS,
      variables: {
        addons: (addons || []).map((x) => x),
        bridgeServiceEligibilityId: bridgeServiceEligibilityId || this.state.bridgeServiceEligibility.id,
      },
      fetchPolicy: 'network-only',
    });

    if (data && data.getBridgeOrderDetails) {
      ord = {
        dueToday: data.getBridgeOrderDetails.dueToday,
        totalDue: data.getBridgeOrderDetails.totalDue,
        memberSavingsAddons: data.getBridgeOrderDetails.memberSavingsAddons,
        discountCoupon: data.getBridgeOrderDetails.discountCoupon,
        items: [],
        registeringForMembership: data.getBridgeOrderDetails.registeringForMembership,
      };
    }
    setorder(ord);
    return ord;
  };

  const getOrderRefresh = async (addons, bridgeServiceEligibilityId) => {
    let ord = {};

    const { data } = await client.query({
      query: GET_BRIDGE_ORDER_DETAILS,
      variables: {
        addons: (addons || []).map((x) => x),
        bridgeServiceEligibilityId: bridgeServiceEligibilityId || this.state.bridgeServiceEligibility.id,
      },
      fetchPolicy: 'network-only',
    });

    if (data && data.getBridgeOrderDetails) {
      ord = {
        dueToday: data.getBridgeOrderDetails.dueToday,
        totalDue: data.getBridgeOrderDetails.totalDue,
        memberSavingsAddons: data.getBridgeOrderDetails.memberSavingsAddons,
        discountCoupon: data.getBridgeOrderDetails.discountCoupon,
        items: [],
        registeringForMembership: data.getBridgeOrderDetails.registeringForMembership,
      };
    }
    setorder(ord);
    return ord;
  };

  const holdSpotForTheNextUpdate = () => {
    const eventTime = moment().add(5, 'minutes'); // Timestamp - Sun, 21 Apr 2013 13:00:00 GMT
    const currentTime = moment(); // Timestamp - Sun, 21 Apr 2013 12:30:00 GMT
    const diffTime = eventTime - currentTime;
    let duration = moment.duration(diffTime, 'milliseconds');
    const interval = 1000;
    setInterval(() => {
      duration = moment.duration(duration - interval, 'milliseconds');
      if (duration > 0) {
        setforTheNext(duration.minutes() + ':' + (duration.seconds() < 10 ? `0${duration.seconds()}` : duration.seconds()));
      } else {
        setforTheNext('-1');
      }
    }, interval);
  };

  const isDoctorInNetwork = (networks, network) => {
    for (let index = 0; index < networks.length; index++) {
      const nt = networks[index];
      if (nt.toLowerCase() === network.toLowerCase()) {
        return true;
      }
    }
    return false;
  };

  const computeDueToday = () => {
    let copay = 0;
    let membership = 0;
    copay =
      bridgeServiceEligibility && bridgeServiceEligibility.patientResponsibility && bridgeServiceEligibility.patientResponsibility.total && bridgeServiceEligibility.patientResponsibility.total > 0
        ? bridgeServiceEligibility.patientResponsibility.total / 100
        : 5;
    if ((!type || type === 'meno') && membershipDescription) {
      if (selectedFromMulti) {
        const m = getPriceDescription(selectedFromMulti);
        if (m) {
          membership = m.price || 0;
        }
      } else {
        membership = membershipDescription ? membershipDescription.price : 0;
      }
    } else {
      membership = membershipDescription ? membershipDescription.price : 0;
    }
    return copay + membership;
  };

  useMount(() => {
    analytics.page('Payment', basePath || '/schedule');
    setisLoadingInsuranceQuote(false);
    setcopayCost(null);
    setcopayError(!!selectedAppointment && selectedAppointment.isInNetwork && (newInsurance || (onFileInsurance && onFileInsurance.use)) ? 'Err' : null);
  });

  return (
    <Flex flexDirection={'column'} style={{ maxWidth: '600px', padding: '0 16px', marginLeft: 'auto', marginRight: 'auto' }} mb={'60px'}>
      <Heading mb={'26px'}>Review your visit</Heading>
      <UpcomingCard visitType="thyroid" text={selectedAppointment.doctor.patientFacingName} noDescription={true}>
        <AvatarImg style={{ alignSelf: 'center' }}>
          <img alt="" src={selectedAppointment.doctor.picture} />
        </AvatarImg>

        <Flex alignItems={'center'}>
          <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M12.5156 5.34375C12.5156 5.42109 12.4523 5.48438 12.375 5.48438H11.3906C11.3133 5.48438 11.25 5.42109 11.25 5.34375V4.5H6.75V5.34375C6.75 5.42109 6.68672 5.48438 6.60938 5.48438H5.625C5.54766 5.48438 5.48438 5.42109 5.48438 5.34375V4.5H3.23438V6.89062H14.7656V4.5H12.5156V5.34375Z"
              fill="#FFE3D8"
            />
            <path
              d="M15.4688 3.23438H12.5156V2.10938C12.5156 2.03203 12.4523 1.96875 12.375 1.96875H11.3906C11.3133 1.96875 11.25 2.03203 11.25 2.10938V3.23438H6.75V2.10938C6.75 2.03203 6.68672 1.96875 6.60938 1.96875H5.625C5.54766 1.96875 5.48438 2.03203 5.48438 2.10938V3.23438H2.53125C2.22012 3.23438 1.96875 3.48574 1.96875 3.79688V15.4688C1.96875 15.7799 2.22012 16.0312 2.53125 16.0312H15.4688C15.7799 16.0312 16.0312 15.7799 16.0312 15.4688V3.79688C16.0312 3.48574 15.7799 3.23438 15.4688 3.23438ZM14.7656 14.7656H3.23438V8.08594H14.7656V14.7656ZM14.7656 6.89062H3.23438V4.5H5.48438V5.34375C5.48438 5.42109 5.54766 5.48438 5.625 5.48438H6.60938C6.68672 5.48438 6.75 5.42109 6.75 5.34375V4.5H11.25V5.34375C11.25 5.42109 11.3133 5.48438 11.3906 5.48438H12.375C12.4523 5.48438 12.5156 5.42109 12.5156 5.34375V4.5H14.7656V6.89062Z"
              fill="#4E658A"
            />
          </svg>

          <Text ml={1} mr={3} fontWeight={300} fontSize={'14px'}>
            {selectedAppointment.slot.date}
          </Text>
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M8.515 1.019C8.34363 1.00635 8.17184 1.00001 8 1V0C8.19654 9.58276e-05 8.393 0.00743414 8.589 0.022L8.515 1.019ZM10.519 1.469C10.1984 1.3453 9.86922 1.24537 9.534 1.17L9.753 0.194C10.136 0.28 10.513 0.394 10.879 0.536L10.519 1.469ZM11.889 2.179C11.746 2.08365 11.5996 1.99359 11.45 1.909L11.943 1.039C12.2849 1.23274 12.6121 1.45132 12.922 1.693L12.307 2.482C12.1714 2.37623 12.032 2.2755 11.889 2.18V2.179ZM13.723 3.969C13.5252 3.68798 13.3069 3.42192 13.07 3.173L13.794 2.483C14.064 2.768 14.314 3.073 14.541 3.393L13.723 3.969ZM14.467 5.321C14.4014 5.16246 14.33 5.00636 14.253 4.853L15.146 4.403C15.3226 4.75409 15.473 5.11774 15.596 5.491L14.646 5.804C14.5923 5.64087 14.5326 5.47976 14.467 5.321ZM14.997 7.828C14.9889 7.48434 14.9555 7.14174 14.897 6.803L15.882 6.633C15.949 7.019 15.988 7.411 15.998 7.803L14.998 7.828H14.997ZM14.866 9.366C14.899 9.196 14.926 9.027 14.947 8.856L15.94 8.979C15.892 9.36915 15.8151 9.75521 15.71 10.134L14.746 9.867C14.792 9.702 14.832 9.535 14.866 9.366ZM13.914 11.745C14.098 11.455 14.26 11.151 14.4 10.837L15.314 11.242C15.154 11.602 14.969 11.948 14.759 12.28L13.914 11.745ZM12.95 12.95C13.072 12.828 13.189 12.702 13.3 12.572L14.058 13.225C13.9296 13.3738 13.7959 13.5179 13.657 13.657L12.95 12.95Z"
              fill="#4E658A"
            />
            <path
              d="M8.00019 1C6.84907 1.00008 5.71574 1.28405 4.70057 1.82674C3.68541 2.36943 2.81974 3.1541 2.18025 4.11125C1.54076 5.0684 1.14719 6.16848 1.03439 7.31406C0.921589 8.45964 1.09304 9.61536 1.53357 10.6789C1.9741 11.7423 2.6701 12.6808 3.55992 13.4111C4.44974 14.1413 5.50593 14.6409 6.63493 14.8655C7.76393 15.0901 8.93089 15.0328 10.0325 14.6987C11.134 14.3645 12.1362 13.7639 12.9502 12.95L13.6572 13.657C12.7269 14.5878 11.5814 15.2747 10.3222 15.657C9.06302 16.0393 7.72896 16.105 6.43826 15.8485C5.14755 15.5919 3.94005 15.021 2.92274 14.1862C1.90543 13.3515 1.10973 12.2787 0.606129 11.0629C0.102528 9.84711 -0.0934196 8.52588 0.0356482 7.21627C0.164716 5.90666 0.614814 4.6491 1.34606 3.55502C2.07731 2.46094 3.06713 1.56411 4.22782 0.944003C5.38851 0.323895 6.68424 -0.000348732 8.00019 2.81458e-07V1Z"
              fill="#4E658A"
            />
            <path
              d="M7.5 3C7.63261 3 7.75979 3.05268 7.85355 3.14645C7.94732 3.24021 8 3.36739 8 3.5V8.71L11.248 10.566C11.3598 10.6334 11.4408 10.7419 11.4736 10.8683C11.5065 10.9946 11.4886 11.1288 11.4238 11.2422C11.3591 11.3556 11.2525 11.4391 11.127 11.4749C11.0014 11.5108 10.8669 11.4961 10.752 11.434L7.252 9.434C7.17547 9.39029 7.11186 9.32712 7.06761 9.25091C7.02335 9.17469 7.00003 9.08813 7 9V3.5C7 3.36739 7.05268 3.24021 7.14645 3.14645C7.24021 3.05268 7.36739 3 7.5 3Z"
              fill="#4E658A"
            />
          </svg>
          <Text ml={1} fontWeight={300} fontSize={'14px'}>
            {moment(selectedAppointment.slot.startTime, 'HH:mm').format('hh:mma')}
          </Text>
          <Text ml={1} fontWeight={300} fontSize={'14px'}>
            {momentTimezone.tz(selectedAppointment.slot.date, 'MM/DD/YYYY', selectedAppointment.slot.timezoneName).format('z')}
          </Text>
        </Flex>
      </UpcomingCard>

      {forTheNext !== '-1' ? (
        <Text mt={'8px'} textAlign="center" mb={'28px'} fontWeight={400}>
          We are holding this slot for the next {forTheNext} minutes.
          <br />
          You may cancel your appointment up to 4 hours in advance at no cost.
        </Text>
      ) : (
        <Text mt={'8px'} textAlign="center" mb={'28px'} fontWeight={400}>
          This slot is no longer held.
          <br />
          You may cancel your appointment up to 4 hours in advance at no cost.
        </Text>
      )}

      <Text fontSize={'16px'} mb={'16px'} style={{ textTransform: 'capitalize' }}>
        {bridgeServiceEligibility &&
        bridgeServiceEligibility.patientResponsibility &&
        bridgeServiceEligibility.patientResponsibility.total &&
        bridgeServiceEligibility.patientResponsibility.total > 0?`ESTIMATED VISIT COST TO YOU`:`PRE-SERVICE DEPOSIT`}
      </Text>

      <Flex flexDirection={'column'} style={{ borderRadius: '14px', border: '1px solid #D3E1FF', backgroundColor: '#D3E1FF', overflow: 'hidden' }}>
        <Flex justifyContent={'space-between'} style={{ padding: '14px 20px' }}>
          <Text fontWeight={600}>{onFileInsurance.payer.name}</Text>
          <Flex alignItems={'center'} justifyContent={'center'}>
            <Flex style={{ height: '24px', width: '24px', borderRadius: '50%', background: '#449174' }} alignItems={'center'} justifyContent={'center'} mr={'6px'}>
              <svg width="10" height="7" viewBox="0 0 10 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M7.94039 0.259101C8.08533 0.120365 8.27821 0.0436659 8.47834 0.0451883C8.67846 0.0467106 8.87016 0.126335 9.013 0.267261C9.15584 0.408186 9.23864 0.599389 9.24393 0.800524C9.24922 1.00166 9.17658 1.19699 9.04135 1.34531L4.93589 6.5074C4.86529 6.58384 4.78009 6.64519 4.68537 6.68778C4.59066 6.73036 4.48837 6.7533 4.38463 6.75524C4.2809 6.75717 4.17784 6.73805 4.08162 6.69902C3.9854 6.65999 3.89799 6.60185 3.82463 6.52809L1.10206 3.79084C1.02624 3.71981 0.96543 3.63415 0.923252 3.53898C0.881073 3.44381 0.858394 3.34107 0.856565 3.23689C0.854737 3.13272 0.873798 3.02924 0.912611 2.93263C0.951423 2.83602 1.00919 2.74826 1.08247 2.67459C1.15575 2.60091 1.24304 2.54283 1.33913 2.50381C1.43522 2.46479 1.53815 2.44562 1.64176 2.44746C1.74538 2.4493 1.84757 2.4721 1.94223 2.51451C2.03689 2.55691 2.12209 2.61805 2.19274 2.69428L4.34733 4.85946L7.92084 0.28186C7.92727 0.273895 7.93311 0.266297 7.94039 0.259101Z"
                  fill="white"
                />
              </svg>
            </Flex>
            <Text style={{ color: '#449174' }}>In Network</Text>
          </Flex>
        </Flex>
        {bridgeServiceEligibility &&
        bridgeServiceEligibility.patientResponsibility &&
        bridgeServiceEligibility.patientResponsibility.total &&
        bridgeServiceEligibility.patientResponsibility.total > 0 ? (
          <Flex flexDirection={'column'} style={{ backgroundColor: 'white', padding: '14px 20px' }}>
            <Flex justifyContent={'space-between'} mb={'12px'}>
              <Text fontSize={'20px'} fontWeight={400}>
                Your estimated copay
              </Text>
              <Text fontSize={'20px'} fontWeight={600}>
                ${bridgeServiceEligibility.patientResponsibility.total / 100}
              </Text>
            </Flex>
            {/* <Text style={{ fontSize: '14px', fontWeight: 300 }}>Your visit will last up to {duration} minutes.</Text> */}
            <Text style={{ fontSize: '14px', fontWeight: 300 }}>
              The copay shown is an estimate and may adjust slightly once your insurance sends us the final EOB. If there is a difference, we'll automatically charge or refund the card on file.
            </Text>
          </Flex>
        ) : (
          <Flex flexDirection={'column'} style={{ backgroundColor: 'white', padding: '14px 20px' }}>
            <Flex justifyContent={'space-between'} mb={'12px'}>
              <Text fontSize={'20px'} fontWeight={400}>
                Temporary authorization
              </Text>
            </Flex>
            {/* <Text style={{ fontSize: '14px', fontWeight: 300 }}>Your visit will last up to {duration} minutes.</Text> */}
            <Text style={{ fontSize: '14px', fontWeight: 300 }}>
              We’re unable to estimate your copay at this time.
              <br />
              We will place a temporary $5 authorization to securely save your payment method.
              <br />
              Once your insurance processes the claim, we’ll adjust the final amount. You’ll only be charged your actual patient responsibility.
            </Text>
          </Flex>
        )}
      </Flex>

      {bridgeServiceEligibility.patientResponsibility.total > 8500 && (
        <Flex mt={'8px'}>
          <svg width="35" height="20" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M7.04183 4.87492H5.9585V3.79159H7.04183M7.04183 9.20825H5.9585V5.95825H7.04183M6.50016 1.08325C5.78884 1.08325 5.08447 1.22336 4.42729 1.49557C3.77011 1.76778 3.17298 2.16677 2.67 2.66976C1.65418 3.68558 1.0835 5.06333 1.0835 6.49992C1.0835 7.93651 1.65418 9.31426 2.67 10.3301C3.17298 10.8331 3.77011 11.2321 4.42729 11.5043C5.08447 11.7765 5.78884 11.9166 6.50016 11.9166C7.93675 11.9166 9.3145 11.3459 10.3303 10.3301C11.3461 9.31426 11.9168 7.93651 11.9168 6.49992C11.9168 5.78859 11.7767 5.08423 11.5045 4.42705C11.2323 3.76987 10.8333 3.17274 10.3303 2.66976C9.82734 2.16677 9.23021 1.76778 8.57303 1.49557C7.91585 1.22336 7.21149 1.08325 6.50016 1.08325Z"
              fill="#354E79"
            />
          </svg>

          <Text style={{ fontSize: '14px' }} ml={'6px'}>
            Our self-pay rate is $60 - you may choose this option instead. Please note if you select self-pay, we won't bill your insurance and the visit won't count toward your deductible.
            <br />{' '}
            <Link
              style={{ color: '#F6A293' }}
              to={{
                pathname: isMeno ? '/schedulemeno-legacy/pickDoctor' : isWeightLoss ? '/schedulewl-legacy/pickDoctor' : '/schedule-legacy/pickDoctor',
                // search: "?sort=name",
                // hash: "#the-hash",
              }}
            >
              <Text style={{ fontSize: '14px', color: '#F6A293', fontWeight: 500 }}>Book self-pay visit {'>>'}</Text>
            </Link>
          </Text>
        </Flex>
      )}

      {membershipDescription ? (
        <>
          <Text fontSize={'16px'} mb={'16px'} mt={'28px'} style={{ textTransform: 'capitalize' }}>
            {!type || type === 'meno' ? 'SELECT YOUR PALOMA MEMBERSHIP OPTIONS' : 'YOUR PALOMA MEMBERSHIP'}
          </Text>
          {!type || type === 'meno' ? (
            <>
              <Flex
                mb={3}
                onClick={() => setSelectedFromMulti('MetabolicReset')}
                flexDirection={'row'}
                style={{
                  cursor: 'pointer',
                  borderRadius: '14px',
                  border: selectedFromMulti === 'MetabolicReset' ? '1px solid #354E79' : '1px solid #D3E1FF',
                  backgroundColor: selectedFromMulti === 'MetabolicReset' ? '#354E79' : 'white',
                  overflow: 'hidden',
                  padding: '14px 20px',
                }}
              >
                <Flex justifyContent={'center'} alignItems={'center'} mr={3}>
                  <Flex
                    style={{
                      width: '20px',
                      height: '20px',
                      borderRadius: '50%',
                      background: 'white',
                      border: selectedFromMulti === 'MetabolicReset' ? '3px solid white' : '3px solid #354E79',
                    }}
                    justifyContent={'center'}
                    alignItems={'center'}
                  >
                    {selectedFromMulti === 'MetabolicReset' && (
                      <Flex
                        style={{
                          width: '14px',
                          height: '14px',
                          borderRadius: '50%',
                          background: '#44A5FF',
                        }}
                      />
                    )}
                  </Flex>
                </Flex>
                <Flex flex={1} flexDirection={'column'}>
                  <Flex justifyContent={'space-between'} mb={'4px'}>
                    <Text fontSize={'16px'} fontWeight={400} style={{ color: selectedFromMulti === 'MetabolicReset' ? 'white' : '' }}>
                      Monthly
                    </Text>
                    <Text fontSize={'16px'} fontWeight={600} style={{ color: selectedFromMulti === 'MetabolicReset' ? 'white' : '' }}>
                      ${multiMembershipDescription2.pricePerMonth}
                      /month
                    </Text>
                  </Flex>
                  <Flex justifyContent={'space-between'}>
                    <Text style={{ fontSize: '14px', fontWeight: 300, color: selectedFromMulti === 'MetabolicReset' ? 'white' : '' }}>{`$${multiMembershipDescription2.price} due today`}</Text>
                    <Text fontSize={'14px'} fontWeight={400} style={{ color: selectedFromMulti === 'MetabolicReset' ? 'white' : '' }}>
                      billed {multiMembershipDescription2.period === 'annual' ? `annualy` : 'monthly'}
                    </Text>
                  </Flex>
                </Flex>
              </Flex>

              <Flex
                onClick={() => setSelectedFromMulti('HormoneRebalance')}
                flexDirection={'row'}
                style={{
                  cursor: 'pointer',
                  borderRadius: '14px',
                  border: selectedFromMulti === 'HormoneRebalance' ? '1px solid #354E79' : '1px solid #D3E1FF',
                  backgroundColor: selectedFromMulti === 'HormoneRebalance' ? '#354E79' : 'white',
                  overflow: 'hidden',
                  padding: '14px 20px',
                }}
              >
                <Flex justifyContent={'center'} alignItems={'center'} mr={3}>
                  <Flex
                    style={{
                      width: '20px',
                      height: '20px',
                      borderRadius: '50%',
                      background: 'white',
                      border: selectedFromMulti === 'HormoneRebalance' ? '3px solid white' : '3px solid #354E79',
                    }}
                    justifyContent={'center'}
                    alignItems={'center'}
                  >
                    {selectedFromMulti === 'HormoneRebalance' && (
                      <Flex
                        style={{
                          width: '14px',
                          height: '14px',
                          borderRadius: '50%',
                          background: '#44A5FF',
                        }}
                      />
                    )}
                  </Flex>
                </Flex>
                <Flex flex={1} flexDirection={'column'}>
                  <Flex justifyContent={'space-between'} mb={'4px'}>
                    <Flex alignItems={'center'}>
                      <Text fontSize={'16px'} fontWeight={400} style={{ color: selectedFromMulti === 'HormoneRebalance' ? 'white' : '' }}>
                        Annual
                      </Text>
                      <Flex
                        ml={2}
                        style={{
                          borderRadius: '20px',
                          padding: '0px 8px',
                          background: '#44A5FF',
                        }}
                      >
                        <Text fontSize={'12px'} fontWeight={300} style={{ color: 'white' }}>
                          SAVE $600
                        </Text>
                      </Flex>
                    </Flex>
                    <Text fontSize={'16px'} fontWeight={600} style={{ color: selectedFromMulti === 'HormoneRebalance' ? 'white' : '' }}>
                      ${multiMembershipDescription.pricePerMonth}
                      /month
                    </Text>
                  </Flex>
                  <Flex justifyContent={'space-between'}>
                    <Text style={{ fontSize: '14px', fontWeight: 300, color: selectedFromMulti === 'HormoneRebalance' ? 'white' : '' }}>{`$${multiMembershipDescription.price} due today`}</Text>
                    <Text fontSize={'14px'} fontWeight={400} style={{ color: selectedFromMulti === 'HormoneRebalance' ? 'white' : '' }}>
                      billed {multiMembershipDescription.period === 'annual' ? `annualy` : 'monthly'}
                    </Text>
                  </Flex>
                </Flex>
              </Flex>
            </>
          ) : (
            <Flex flexDirection={'column'} style={{ borderRadius: '14px', border: '1px solid rgba(255, 211, 203, 0.50)', backgroundColor: 'rgba(255, 211, 203, 0.50)', overflow: 'hidden' }}>
              <Flex flexDirection={'column'} style={{ padding: '14px 20px' }}>
                <Flex justifyContent={'space-between'} mb={'4px'}>
                  <Text fontSize={'16px'} fontWeight={400}>
                    {membershipDescription.name}
                  </Text>
                  <Text fontSize={'16px'} fontWeight={600}>
                    ${membershipDescription.pricePerMonth}
                    /month
                  </Text>
                </Flex>
                <Flex justifyContent={'space-between'}>
                  <Text style={{ fontSize: '14px', fontWeight: 300 }}>{membershipDescription.period === 'annual' ? `$${membershipDescription.price} due today` : ''}</Text>
                  <Text fontSize={'14px'} fontWeight={400}>
                    billed {membershipDescription.period === 'annual' ? `annualy` : 'monthly'}
                  </Text>
                </Flex>
              </Flex>
            </Flex>
          )}
        </>
      ) : null}

      <Box style={{ height: '2px', background: '#354E79', width: '100%' }} mt={'26px'} mb={'26px'} />

      <Flex flexDirection={'column'} style={{ borderRadius: '14px', border: 'transparent', backgroundColor: 'transparent', overflow: 'hidden' }} mb={'26px'}>
        <Flex flexDirection={'column'} style={{ padding: '0 20px' }}>
          <Flex justifyContent={'space-between'} mb={'8px'}>
            <Text fontSize={'20px'} fontWeight={400}>
              Amount charged today
            </Text>
            <Text fontSize={'20px'} fontWeight={600}>
              ${computeDueToday()}
            </Text>
          </Flex>
        </Flex>
      </Flex>

      <CheckoutFormBridgeNew
        membershipType={!type || type === 'meno' ? (addMembership ? selectedFromMulti || addMembership : null) : addMembership}
        type={type}
        rescheduleAppointmentId={rescheduleAppointmentId}
        consents={consents}
        bridgeServiceEligibility={bridgeServiceEligibility}
        addons={[addMembership ? 'membership' : null]}
        selectedAppointment={selectedAppointment}
        onCompleted={onCompleted}
      />
      <Flex flexDirection="row" justifyContent="center" alignItems="center">
        <svg width="23" height="24" viewBox="0 0 23 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M17.7931 24H5.20542C5.07722 24.0001 4.95026 23.9753 4.8318 23.9271C4.71333 23.8788 4.6057 23.8081 4.51505 23.7188C4.4244 23.6296 4.35251 23.5237 4.30349 23.407C4.25448 23.2904 4.2293 23.1655 4.2294 23.0393V13.8716C4.2294 13.3406 4.66598 12.9071 5.20542 12.9071H6.38792V11.4266C6.38792 8.65323 8.68129 6.3958 11.4989 6.3958C14.3164 6.3958 16.6098 8.65323 16.6098 11.4266V12.9071H17.7923C18.3317 12.9071 18.7683 13.3406 18.7683 13.8716V23.0393C18.7684 23.1655 18.7432 23.2904 18.6942 23.407C18.6452 23.5237 18.5733 23.6296 18.4827 23.7188C18.392 23.8081 18.2844 23.8788 18.1659 23.9271C18.0475 23.9753 17.9213 24.0001 17.7931 24ZM12.1389 18.9302C13.2977 18.2859 12.833 16.5437 11.4996 16.5437C10.1701 16.5475 9.70607 18.2822 10.8604 18.9302V20.1721C10.8604 21.0083 12.1381 21.0083 12.1381 20.1721L12.1389 18.9302ZM9.3213 12.9063H13.6825V11.4259C13.6825 10.2424 12.7027 9.28171 11.4996 9.28171C10.2966 9.28171 9.3213 10.2424 9.3213 11.4259V12.9063ZM3.92845 11.5436H0.892967C0.396959 11.5436 0 11.1492 0 10.6647C0 10.1802 0.396959 9.7857 0.892967 9.7857H3.92845C4.42064 9.7857 4.82141 10.1802 4.82141 10.6647C4.82141 11.1492 4.42064 11.5436 3.92845 11.5436ZM6.06715 6.84054C5.86064 6.84092 5.66075 6.76886 5.50333 6.63729L3.09872 4.69185C3.0083 4.61866 2.93347 4.5286 2.87853 4.42685C2.82359 4.3251 2.78962 4.21366 2.77857 4.09895C2.76752 3.98423 2.77962 3.86849 2.81417 3.75839C2.84871 3.64829 2.90502 3.546 2.97986 3.45739C3.05394 3.36812 3.14523 3.29414 3.24847 3.23972C3.3517 3.1853 3.46485 3.1515 3.5814 3.14028C3.69796 3.12906 3.81561 3.14063 3.92761 3.17433C4.0396 3.20803 4.14372 3.26319 4.23397 3.33665L6.63859 5.28208C7.28545 5.80557 6.90449 6.84054 6.06715 6.83679V6.84054ZM11.4996 4.76985C11.2629 4.76945 11.036 4.67672 10.8686 4.51197C10.7013 4.34721 10.6071 4.12387 10.6067 3.89088V0.878973C10.6067 0.394488 11.0074 0 11.4996 0C11.9918 0 12.3926 0.394488 12.3926 0.878973V3.89088C12.3926 4.37536 11.9918 4.76985 11.4996 4.76985ZM16.9321 6.84054C16.0909 6.84054 15.7138 5.80557 16.3607 5.28208L18.7653 3.33665C19.6857 2.59417 20.8171 3.95013 19.9005 4.69635L17.4959 6.64179C17.3373 6.77088 17.1379 6.84068 16.9321 6.84054ZM22.107 11.5436H19.0434C18.5474 11.5436 18.1504 11.1492 18.1504 10.6647C18.1504 10.1802 18.5474 9.7857 19.0434 9.7857H22.107C22.603 9.7857 23 10.1802 23 10.6647C23 11.1492 22.603 11.5436 22.107 11.5436Z"
            fill="#F6A293"
          />
        </svg>

        <Text fontSize="12px" fontWeight="300" ml={3}>
          Payment information protected and encrypted
        </Text>
      </Flex>

      <Box style={{ height: '2px', background: '#354E79', width: '100%' }} mt={'60px'} mb={'26px'} />
      {!!addMembership && (
        <Flex flexDirection={'column'} style={{ borderRadius: '14px', border: 'transparent', backgroundColor: 'transparent', overflow: 'hidden' }} mb={'26px'}>
          <Flex flexDirection={'column'} style={{ padding: '0 20px' }}>
            <Text fontSize={'22px'} fontWeight={600} mb={3}>
              What’s included in your membership:
            </Text>
            <ul>
              <li>
                <Text>Access to the Paloma Health platform</Text>
              </li>
              <li>
                <Text> Access to board certified clinicians, coaches, and prescriptions (if medically appropriate)</Text>
              </li>
              <li>
                <Text>Lifestyle guidance + accountability</Text>
              </li>
              <li>
                <Text>Convenient mobile app</Text>
              </li>
              <li>
                <Text>Responsive care team access</Text>
              </li>
            </ul>
            <Text fontSize={'22px'} mt={'16px'} fontWeight={600} mb={3}>
              What’s not included:
            </Text>
            <ul>
              <li>
                <Text>Medication, labs and clinical services have additional costs</Text>
              </li>
            </ul>
            <Text fontSize={'22px'} mt={'20px'} fontWeight={600} mb={3}>
              Membership terms and billing policies
            </Text>
            <Text fontSize={'16px'} fontWeight={600} mb={3}>
              Cancellation
            </Text>
            <Text mb={3}>
              You can cancel your subscription at any time by contacting our customer support team at care@palomahealth.com. You can also cancel your membership by clicking the “Cancel Membership”
              link in your Account page on the app or the portal.
            </Text>

            <Text fontSize={'16px'} fontWeight={600} mb={3} mt={3}>
              Auto-renewal
            </Text>
            <Text mb={3}>Your membership will automatically renew at the end of each billing cycle until you cancel.</Text>

            <Text fontSize={'16px'} fontWeight={600} mb={3} mt={3}>
              Billing Cycle Details
            </Text>
            <ul>
              <li>
                <Text>You will be charged monthly/annually based on your selected plan until you cancel.</Text>
              </li>
              <li>
                <Text>Payment will be automatically deducted from the payment method you provide at checkout.</Text>
              </li>
            </ul>
          </Flex>
        </Flex>
      )}
    </Flex>
  );
};

class CheckoutForm extends Component {
  constructor(props) {
    super(props);
    // this.log();
    const { selectedAppointment, reinitFlow, wizard, session, addMembership, quadPaySubscribedData, bridgeServiceEligibility } = this.props;
    let regularCost = (session && session.isMember) || !!addMembership || !!quadPaySubscribedData ? 60 : 110;
    if (props.isWeightLoss) {
      regularCost = (session && session.isWeightLossMember) || !!addMembership || !!quadPaySubscribedData ? 60 : 110;
    }

    this.state = {
      step: 'payment',
      isLoadingInsuranceQuote: true,
      regularCost: regularCost,
      copayCost: bridgeServiceEligibility.patientResponsibility.total,
      copayLoaded: false,
      billingSameAsShiping: true,
      forTheNext: null,
      quadpayOrderReference: uuidv4(),
      order: null,
    };
    if (!selectedAppointment) {
      reinitFlow(wizard);
    }
    this.getOrder(null, bridgeServiceEligibility.id);
    this.holdSpotForTheNextUpdate();
  }
  log = () => {
    if (window._env_.REACT_APP_GRAPHQL_URL.indexOf('localhost') < 0) return;

    const {
      selectedAppointment,
      reinitFlow,
      wizard,
      session,
      addMembership,
      quadPaySubscribedData,
      bridgeServiceEligibility,
      setQuadPayData,
      client,
      newInsurance,
      onFileInsurance,
      analytics,
      toastManager,
      isNewPatientFlow,
      storeCard,
      handlePayment,
      isAdmin,
      enforcePatientId,
      duration,
      isWeightLoss,
      type,
      isMeno,
      basePath,
    } = this.props;
    // console.log(JSON.stringify(selectedAppointment));
    // console.log(JSON.stringify(addMembership));
    // console.log(JSON.stringify(quadPaySubscribedData));
    // console.log(JSON.stringify(bridgeServiceEligibility));
    // console.log(JSON.stringify(newInsurance));
    // console.log(JSON.stringify(onFileInsurance));
    // console.log(JSON.stringify(isNewPatientFlow));
    // console.log(JSON.stringify(storeCard));
    // console.log(JSON.stringify(isWeightLoss));
    // console.log(JSON.stringify(duration));
    // console.log(JSON.stringify(type));
    // console.log(JSON.stringify(isMeno));
    // console.log(JSON.stringify(basePath));
  };
  componentDidMount() {}

  onCompleteCallback = function(result) {
    const { setQuadPayData } = this.props;
    const { quadpayOrderReference } = this.state;

    setQuadPayData(result.card.number, result.card.cvc, result.card.expirationMonth, result.card.expirationYear, quadpayOrderReference);
  };

  getOrder = async (addons, bridgeServiceEligibilityId) => {
    const { client } = this.props;
    let order = {};

    const { data } = await client.query({
      query: GET_BRIDGE_ORDER_DETAILS,
      variables: {
        addons: (addons || []).map((x) => x),
        bridgeServiceEligibilityId: bridgeServiceEligibilityId || this.state.bridgeServiceEligibility.id,
      },
      fetchPolicy: 'network-only',
    });

    if (data && data.getBridgeOrderDetails) {
      order = {
        dueToday: data.getBridgeOrderDetails.dueToday,
        totalDue: data.getBridgeOrderDetails.totalDue,
        memberSavingsAddons: data.getBridgeOrderDetails.memberSavingsAddons,
        discountCoupon: data.getBridgeOrderDetails.discountCoupon,
        items: [],
        registeringForMembership: data.getBridgeOrderDetails.registeringForMembership,
      };
    }
    this.setState({
      order,
    });
    return order;
  };

  holdSpotForTheNextUpdate = () => {
    const eventTime = moment().add(5, 'minutes'); // Timestamp - Sun, 21 Apr 2013 13:00:00 GMT
    const currentTime = moment(); // Timestamp - Sun, 21 Apr 2013 12:30:00 GMT
    const diffTime = eventTime - currentTime;
    let duration = moment.duration(diffTime, 'milliseconds');
    const interval = 1000;
    setInterval(() => {
      duration = moment.duration(duration - interval, 'milliseconds');
      if (duration > 0) {
        this.setState({
          forTheNext: duration.minutes() + ':' + (duration.seconds() < 10 ? `0${duration.seconds()}` : duration.seconds()),
        });
      } else {
        this.setState({
          forTheNext: '-1',
        });
      }
    }, interval);
  };

  isDoctorInNetwork = (networks, network) => {
    for (let index = 0; index < networks.length; index++) {
      const nt = networks[index];
      if (nt.toLowerCase() === network.toLowerCase()) {
        return true;
      }
    }
    return false;
  };

  componentDidMount = async () => {
    const { newInsurance, onFileInsurance, selectedAppointment } = this.props;

    this.setState(
      {
        isLoadingInsuranceQuote: false,
        copayCost: null,
        copayError: !!selectedAppointment && selectedAppointment.isInNetwork && (newInsurance || (onFileInsurance && onFileInsurance.use)) ? 'Err' : null,
      },
      () => {}
    );
  };

  componentDidMount() {
    this.props.analytics.page('Payment', this.props.basePath || '/schedule');
  }

  updatePayment = async (values, actions) => {
    const { client, toastManager, isNewPatientFlow, storeCard } = this.props;
    try {
      const expiration = values.expirationdate.split('/');
      if (expiration.length !== 2) {
        toastManager.add('Invalid Expiration Date.', {
          appearance: 'error',
        });
        actions.setSubmitting(false);
        return;
      }
      if (expiration[1].toString().length < 2) {
        toastManager.add('Invalid Expiration Date.', {
          appearance: 'error',
        });
        actions.setSubmitting(false);
        return;
      }
      if (expiration[0].toString().length < 1 || expiration[0].toString().length > 2) {
        toastManager.add('Invalid Expiration Date.', {
          appearance: 'error',
        });
        actions.setSubmitting(false);
        return;
      }
      storeCard({
        accountNumber: values.cardnumber,
        cvc: values.cvc2,
        expMonth: expiration[0].length < 2 ? `0${expiration[0]}` : expiration[0],
        expYear: expiration[1].toString().substr(expiration[1].length - 2),
        zip: values.zip || null,
        street1: values.street1 || null,
      });

      if (isNewPatientFlow) {
        actions.setSubmitting(false);
        this.setState({
          step: 'review',
          emulatedAthenaCard: {
            last4: values.cardnumber.slice(-4),
            expMonth: expiration[0].length < 2 ? `0${expiration[0]}` : expiration[0],
            expYear: expiration[1].toString().substr(expiration[1].length - 2),
            brand: '',
          },
        });
        return;
      } else {
        this.setState({
          step: 'review',
          emulatedAthenaCard: {
            last4: values.cardnumber.slice(-4),
            expMonth: expiration[0].length < 2 ? `0${expiration[0]}` : expiration[0],
            expYear: expiration[1].toString().substr(expiration[1].length - 2),
            brand: '',
          },
        });
      }
      this.setState({ step: 'review' });
    } catch (error) {
      console.log(error);
      actions.setSubmitting(false);
    }
  };

  render() {
    const {
      handlePayment,
      selectedAppointment,
      wizard,
      isAdmin,
      enforcePatientId,
      isNewPatientFlow,
      duration,
      addMembership,
      session,
      quadPaySubscribedData,
      isWeightLoss,
      bridgeServiceEligibility,
      type,
      isMeno,
    } = this.props;

    const { copayCost, regularCost, isLoadingInsuranceQuote, emulatedAthenaCard, couldntConfirmCard, aCard, copayError, cardLoaded, order, forTheNext } = this.state;
    // // console.log('SchedulePaymentBridge', { session, addMembership });
    if (!selectedAppointment || !order) {
      return <div />;
    }
    // // console.log({order})
    return (
      <Fragment>
        {this.state.step === 'payment' && (
          <>
            {!quadPaySubscribedData ? (
              forTheNext !== '-1' ? (
                <Text textAlign="center" mb={3}>
                  We are holding this slot for the next
                  <br />
                  {forTheNext} minutes.
                </Text>
              ) : (
                <Text textAlign="center" mb={3}>
                  This slot is no longer held.
                </Text>
              )
            ) : (
              <Text textAlign="center" mb={3}>
                <span style={{ fontWeight: 600 }}>Welcome to the Paloma Membership!</span>
                <br />
                Finish booking your visit
              </Text>
            )}
            <Flex flexDirection={['column', 'column', 'row']} px={3}>
              <BoxLeft flexDirection="column" flex={1} className={!isLoadingInsuranceQuote ? 'loaded' : ''}>
                <CheckoutFormBridge
                  membershipType={addMembership}
                  type={type}
                  rescheduleAppointmentId={this.props.rescheduleAppointmentId}
                  consents={this.props.consents}
                  bridgeServiceEligibility={bridgeServiceEligibility}
                  addons={[addMembership ? 'membership' : null]}
                  selectedAppointment={selectedAppointment}
                  onCompleted={this.props.onCompleted}
                />
              </BoxLeft>

              <BoxRight
                className={!isLoadingInsuranceQuote ? 'loaded' : ''}
                mb={[4, 4, 0]}
                flexDirection="column"
                order={[-1, -1, 3]}
                style={{
                  paddingLeft: !!isMobile ? '0' : '16px',
                  paddingRight: !!isMobile ? '0' : '16px',
                  minWidth: '310px',
                }}
              >
                <Box onClick={() => this.setState({ copayLoaded: true })}>
                  <Card p={4}>
                    <Flex flexDirection="column">
                      <Flex mb={3} justifyContent="center">
                        {selectedAppointment && selectedAppointment.doctor && selectedAppointment.doctor.picture ? (
                          <Avatar>
                            <img src={selectedAppointment.doctor.picture} alt="" />
                          </Avatar>
                        ) : (
                          <img src={DoctorIcon} alt="" height="200px" />
                        )}
                      </Flex>

                      <Flex mb={3} justifyContent="center">
                        <Text textAlign="center" fontSize={3} fontWeight={700}>
                          Video visit with
                          <br />
                          {selectedAppointment && selectedAppointment.doctor && selectedAppointment.doctor.patientFacingName ? selectedAppointment.doctor.patientFacingName : 'A Thyroid Doctor'}
                        </Text>
                      </Flex>
                      {isLoadingInsuranceQuote ? (
                        <Flex mb={3} justifyContent="center" flexDirection="column" textAlign="center">
                          <SpinLoader style={{ margin: '0 auto' }} width="25" height="25" />
                          <Text fontWeight="400" textAlign="center" mt={3}>
                            We Are Retrieving Your Quote
                          </Text>
                        </Flex>
                      ) : (
                        <Flex mb={copayError ? 2 : 3} justifyContent="center">
                          <Text textAlign="center" fontSize={copayError ? '16px' : 3} fontWeight={700} style={{ marginTop: '8px' }}>
                            {order.totalDue || order.totalDue === 0 ? (
                              <Fragment>
                                <span style={{ fontWeight: '400' }}>{`Your Copay: `}</span>
                                {`$${order.totalDue / 100}`}
                              </Fragment>
                            ) : copayError ? (
                              'An error occured retrieving your quote'
                            ) : (
                              `$${regularCost}`
                            )}
                          </Text>
                        </Flex>
                      )}

                      <Flex mb={3} justifyContent="center" flexDirection="column">
                        {copayError && (
                          <TextDescriptionAppointment className={!isLoadingInsuranceQuote ? 'loaded' : ''} textAlign="center" fontSize={1} mb={4} fontWeight={200}>
                            <>
                              <span>
                                Please note it can take up to 6 weeks for the claim to be completed. You will be charged for any co-insurance, co-pays, and deductibles. Most patients pay only their
                                co-pay.
                              </span>

                              {((this.props.session && this.props.session.isMember && this.props.session.membershipSpecific === 'insurance') || (addMembership && addMembership === 'mi')) && (
                                <span>
                                  <br />
                                  If your insurance cannot be billed for this visit, your cash pay price will be $110.
                                </span>
                              )}
                            </>
                          </TextDescriptionAppointment>
                        )}
                        <Flex mb={3} justifyContent="center" />
                        {!!isToggleActive('MEMBERSHIP_ONLY') &&
                          !!addMembership &&
                          !quadPaySubscribedData && (
                            <>
                              <TextDescriptionAppointment className={!isLoadingInsuranceQuote ? 'loaded' : ''} textAlign="center" fontSize={1} fontWeight={200} mb={2}>
                                {this.props.textDescriptionPrice
                                  ? this.props.textDescriptionPrice()
                                  : `Your ${
                                      addMembership === 'mi' ? '$96' : `$${isToggleActive('MEMBERSHIP_PRICE_2024') ? Constants.MEMBERSHIP_PRICE_2024 : Constants.MEMBERSHIP_PRICE}`
                                    } annual membership fee will be charged today.`}
                              </TextDescriptionAppointment>
                            </>
                          )}
                        <TextDescriptionAppointment className={!isLoadingInsuranceQuote ? 'loaded' : ''} textAlign="center" fontSize={1} fontWeight={200} mb={3}>
                          {`Your video visit will last up to ${duration || 30} minutes. You can join the visit with any smartphone or computer equipped with a webcam.`}
                        </TextDescriptionAppointment>
                      </Flex>
                    </Flex>
                  </Card>
                </Box>
              </BoxRight>
            </Flex>
          </>
        )}

        {this.state.step === 'review' && (
          <Review
            forTheNext={forTheNext}
            copayError={copayError}
            regularCost={regularCost}
            copayCost={copayCost}
            selectedAppointment={selectedAppointment}
            athenaCard={emulatedAthenaCard || aCard}
            handlePayment={handlePayment}
            analytics={this.props.analytics}
            wizard={wizard}
            couldntConfirmCard={couldntConfirmCard}
            addMembership={addMembership}
            session={session}
            textDescriptionPrice={this.props.textDescriptionPrice}
            isWeightLoss={isWeightLoss}
            isMeno={isMeno}
          />
        )}
      </Fragment>
    );
  }
}
const ELEMENTS_OPTIONS = {
  fonts: [
    {
      cssSrc: 'https://fonts.googleapis.com/css?family=Poppins',
    },
  ],
};
const SchedulePaymentBridge = ({ addons, values, hpiContent, getState, onSubmit, consents, ...props }) => {
  const stripePromise = loadStripe(window._env_.REACT_APP_STRIPE_KEY);

  return (
    <Elements stripe={stripePromise} options={ELEMENTS_OPTIONS}>
      <CheckoutForm consents={consents} addons={addons} values={values} hpiContent={hpiContent} getState={getState} onSubmit={onSubmit} {...props} />
    </Elements>
  );
};

export const SchedulePaymentBridgeUnregistered = compose(
  withApollo,
  withToastManager,
  withAnalytics,
  withWizard
)(SchedulePaymentBridge);

export const SchedulePaymentBridgeNew = compose(
  withApollo,
  withToastManager,
  withAnalytics,
  withWizard,
  withSession
)(({ addons, values, hpiContent, getState, onSubmit, consents, ...props }) => {
  const stripePromise = loadStripe(window._env_.REACT_APP_STRIPE_KEY);

  return (
    <Elements stripe={stripePromise} options={ELEMENTS_OPTIONS}>
      <CheckoutFormNew consents={consents} addons={addons} values={values} hpiContent={hpiContent} getState={getState} onSubmit={onSubmit} {...props} />
    </Elements>
  );
});

export default compose(
  withApollo,
  withToastManager,
  withAnalytics,
  withWizard,
  withSession
)(SchedulePaymentBridge);
